import {Component, OnInit, ViewChild} from '@angular/core';
import {FirestoreService} from 'src/app/services/firestore.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import {Router} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import Swal from 'sweetalert2';
import {UtilService} from '../../../services/util.service';
import {Sort} from '@angular/material/sort';
import { ICellRendererAngularComp } from "ag-grid-angular"
import { ICellRendererParams} from "ag-grid-community"
export interface CellRendererComponent{
  // projectDetails: any
}

@Component({
  selector: 'app-cell-renderer',
  templateUrl: './cell-renderer.component.html',
  styleUrls: ['./cell-renderer.component.scss']
})
export class CellRendererComponent implements OnInit, ICellRendererAngularComp {

  project = {}
  parentContext
  archiveMode
  roles:any
  constructor(
    private utils:UtilService
  ) {
    //  this.util.getRoles().then((res:any)=>{
    //   this.roles=res['data']
    // })
  }
  public actions = {deleteProject:['executive_manager'],detailsBtn:['admin']}

  async agInit(params: ICellRendererParams<any, any, any>) {
    this.roles= params.context.componentParent.roles
    this.project = params.data
    this.parentContext = params.context
    this.archiveMode = params.context.componentParent.archiveMode
  }
  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return false
  }
  ngOnInit(): void {
  }


  emitEvent(type) {
  this.parentContext.componentParent.clickedMenu = type
  }
}
